__webpack_require__.p = "https://static.age.awaze.com/search-mfe/7ebdf8b/_next/";